import * as React from 'react';
import { useRef, useState} from 'react';
import {
    Tooltip, Chip, TextField, Autocomplete, InputLabel, Input, Button, Card, 
    Divider, FormControl, FormLabel, Stack, Typography, Box,
} from '@mui/material'
import RemoveIcon from "@mui/icons-material/RemoveCircleOutlineSharp";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowDownAZ, faArrowUpAZ} from '@fortawesome/free-solid-svg-icons'
import RadioIconButtonGroup from '../RadioIconButtonGroup'
import ScheduleIcon from '@mui/icons-material/Schedule';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import GradeIcon from '@mui/icons-material/Grade';

import * as CONSTANTS from "../../constants"


const WazarenFilters = ({resetFilter, submitFilter, lang}) => {

    const [tags, setTags] = useState([]);
    const [noTags, setNoTags] = useState([]);
    const [sortOption, setSortOption] = useState('a_to_z');

    const [skillName, setSkillName] = useState('');
    const [creatorName, setCreatorName] = useState('');

    let tagKeys = []
    for (let index = 1; index <= Object.keys(CONSTANTS.WAZAREN_TAGS).length; index++) {
        tagKeys.push(index);
    }

    const ResetFilter = () => {
        setSkillName('');
        setCreatorName('');
        setTags([]);
        setNoTags([]);
        resetFilter();
    }
    
    const GetFilter = () => {
        let params = new URLSearchParams({});
        params.append('page', 1);
        if (skillName !== '')  params.append('name', skillName);
        if (creatorName !== '')  params.append('creatorName', creatorName);
        tags.forEach(tag => {
            params.append('tags', tag);
        });
        noTags.forEach(tag => {
            params.append('noTags', tag);
        });
        params.append('sort', sortOption);
        submitFilter(params);
    };

    return (
        <Card
            sx={{
                borderRadius: 'md',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                overflow: "auto",
                minWidth: "300px",
            }}
        >
            <Box sx={{ gap: 2 }}>
                <Stack
                    direction={'column'}
                    spacing={2}
                >
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold' }}>{CONSTANTS.WAZAREN_FILTER.SORTING_OPTION[lang]}</FormLabel>
                    <RadioIconButtonGroup 
                        hook={sortOption}
                        setHook={setSortOption}
                        buttonValues={[
                            'a_to_z', 'z_to_a', // 'date_created', 'clicks', 'likes', 'ratings',
                        ]}
                        buttonIcons={{
                            'a_to_z': <FontAwesomeIcon icon={faArrowDownAZ} />,
                            'z_to_a': <FontAwesomeIcon icon={faArrowUpAZ} />,
                            'date_created': <ScheduleIcon />,
                            'clicks': <VisibilityIcon />,
                            'likes': <ThumbUpIcon />,
                            'ratings': <GradeIcon />,
                        }}
                        buttonDisableds={{
                            'a_to_z': false,
                            'z_to_a': false,
                            'date_created': true,
                            'clicks': true,
                            'likes': true,
                            'ratings': true
                        }}
                        tooltipValues={{
                            'a_to_z': 'Name (A to Z)',
                            'z_to_a': 'Name (Z to A)',
                            'date_created': 'Date Created',
                            'clicks': 'Clicks',
                            'likes': 'Likes',
                            'ratings': 'Ratings'
                        }}
                    />
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold', mb: 2 }}>{CONSTANTS.WAZAREN_FILTER.SEARCHING_OPTION[lang]}</FormLabel>
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold', mb: 1 }}>{CONSTANTS.WAZAREN_FILTER.SKILL_NAME[lang]}</FormLabel>
                    <Input 
                        placeholder={CONSTANTS.WAZAREN_FILTER.SKILL_NAME_PLACEHOLDER[lang]}
                        value={skillName}
                        onChange={(e)=> setSkillName(e.target.value)}
                        sx={{
                            mb: 2 
                        }}
                    />
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold', mb: 1 }}>{CONSTANTS.WAZAREN_DETAILS.CREATOR[lang]+" / "+CONSTANTS.WAZAREN_DETAILS.EDITOR[lang]}</FormLabel>
                    <Input 
                        placeholder={CONSTANTS.WAZAREN_FILTER.CREATOR_PLACEHOLDER[lang]}
                        value={creatorName}
                        onChange={(e)=> setCreatorName(e.target.value)}
                        sx={{
                            mb: 2 
                        }}
                    />

                    <Typography level="title-md" fontWeight="bold" sx={{ mb: 2 }}>{CONSTANTS.WAZAREN_FILTER.TAGS[lang]}</Typography>
                    <InputLabel>{CONSTANTS.WAZAREN_FILTER.INCLUDE[lang]}</InputLabel>
                    <Stack 
                        className="selectedTags"
                        direction="row" 
                        spacing={1}
                        useFlexGap
                        flexWrap="wrap"
                    >
                        {
                            tags.map((option, index) => {
                                // This is to handle new options added by the user (allowed by freeSolo prop).
                                const label = CONSTANTS.WAZAREN_TAGS[option][lang] || option;
                                return (
                                    <Chip 
                                        size="medium"
                                        variant="outlined"
                                        key={option}
                                        label={label}
                                        deleteIcon={<RemoveIcon />} 
                                        onDelete={() => {
                                            setTags(tags.filter(entry => entry !== option));
                                        }}
                                        sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                        }}
                                    />
                                );
                            })
                        }
                    </Stack>
                    <Autocomplete
                        multiple
                        id="tags-standard"
                        freeSolo
                        filterSelectedOptions
                        options={tagKeys}
                        onChange={(e, newValue) => setTags(newValue)}
                        getOptionLabel={tagKey => CONSTANTS.WAZAREN_TAGS[tagKey][lang]}
                        renderTags={() => {}}
                        value={tags}
                        componentsProps={{
                            paper: {
                                sx: { width: '100%' }
                            }
                        }}
                        renderInput={params => (
                        <TextField
                            {...params}
                            variant="standard"
                            placeholder=""
                            margin="normal"
                            fullWidth
                        />
                        )}
                    />
                    <InputLabel sx={{mt: 2}}>{CONSTANTS.WAZAREN_FILTER.EXCLUDE[lang]}</InputLabel>
                    <Stack 
                        className="selectedTags"
                        direction="row" 
                        spacing={1}
                        useFlexGap
                        flexWrap="wrap"
                    >
                        {
                            noTags.map((option, index) => {
                                // This is to handle new options added by the user (allowed by freeSolo prop).
                                const label = CONSTANTS.WAZAREN_TAGS[option][lang] || option;
                                return (
                                    <Chip 
                                        size="medium"
                                        variant="outlined"
                                        key={option}
                                        label={label}
                                        deleteIcon={<RemoveIcon />} 
                                        onDelete={() => {
                                            setNoTags(noTags.filter(entry => entry !== option));
                                        }}
                                        sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                        }}
                                    />
                                );
                            })
                        }
                    </Stack>
                    <Autocomplete
                        multiple
                        id="tags-standard"
                        freeSolo
                        filterSelectedOptions
                        options={tagKeys}
                        onChange={(e, newValue) => setNoTags(newValue)}
                        getOptionLabel={option => CONSTANTS.WAZAREN_TAGS[option][lang]}
                        renderTags={() => {}}
                        value={noTags}
                        componentsProps={{
                            paper: {
                                sx: {
                                    width: '100%'
                                }
                            }
                        }}
                        renderInput={params => (
                        <TextField
                            {...params}
                            variant="standard"
                            placeholder=""
                            margin="normal"
                            fullWidth
                        />
                        )}
                    />
                </Stack>
            </Box>

          <Divider sx={{ mt: 'auto' }} />
          <Stack
            direction="row"
            justifyContent="space-between"
            useFlexGap
            spacing={1}
          >
            <Button
              variant="outlined"
              color="neutral"
              onClick={ResetFilter}
            >
              {CONSTANTS.WAZAREN_FILTER.RESET[lang]}
            </Button>
            <Button
                variant='contained'
                color="primary"
                onClick={GetFilter}
            >
                {CONSTANTS.WAZAREN_FILTER.SEARCH[lang]}
            </Button>
        </Stack>
    </Card>
  );
};

export default WazarenFilters;
